const NotFoundPage = () => <h1 className="h2 mb-3">Ops...pagina non trovata!</h1>;

export default NotFoundPage;
